// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Report-ReportGraph-root-1p3dz","title":"src-components-Report-ReportGraph-title-1mQ8S","graph":"src-components-Report-ReportGraph-graph-2Ku50","ring":"src-components-Report-ReportGraph-ring-tbZV5","time":"src-components-Report-ReportGraph-time-drWkV","count":"src-components-Report-ReportGraph-count-EF5F2","text":"src-components-Report-ReportGraph-text-1gyVj","desc":"src-components-Report-ReportGraph-desc-1u0fT"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Report/ReportGraph.css
 ** module id = 282
 ** module chunks = 0
 **/